import React from "react";
import { useTranslation } from "react-i18next";

const BulkImportPartnerStep3 = ({ prevStep, handleImport }) => {
  const { t: translator } = useTranslation();

  return (
    <>
      <div className="row">
        <div className="col-12">{translator("BulkImport-ReadyData")}</div>
      </div>
      <div className="row mt-3">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={prevStep}>
            {translator("Onboarding-Btn-Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-primary" onClick={handleImport}>
            {translator("Btn-Save")}
          </button>
        </div>
      </div>
    </>
  );
};

export default BulkImportPartnerStep3;
